import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';
import LoadingOverlay from 'react-loading-overlay';

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  // 予約内容
  const [schedules, setSchedules] = useState([]);

  // 検索内容
  const [searchPlaKbn, setSearchPlaKbn]  = useState(["30", "40"]);

  // 削除用
  const [deleteSchedule, setDeleteSchedule] = useState({id: 0, plan_datetime_from: "", plan_kbn: "", m_institution_id: "", institution_name: ""});

  // ロード
  const [isLoading, setIsLoading]  = useState<Boolean>(true);
  // メッセージエリア
  const [infoMessage, setInfoMessage] = useState("");
  // エラーメッセージエリア
  const [errorMessage, setErrorMessage] = useState("");

  // 初期ロード
  useEffect(() =>{
    searchSchedule();
  }, [])

  // チェックボックス更新
  function changeSearchPlaKbn(target) {
    if (target.checked){
      setSearchPlaKbn([...searchPlaKbn, target.value]);
    }else{
      setSearchPlaKbn(searchPlaKbn.filter(value => value !== target.value));
    }
  }

  // 予約区分名を表示
  function setPlanKbn(plan_kbn){
    switch(plan_kbn){
      case 40:
        return <span className="badge badge-pill badge-danger">予約未確定</span>
      case 30:
        return <span className="badge badge-pill badge-success">予約確定</span>
      default:
        return <span className="badge badge-pill badge-primary"></span>
    }
  }

  // 削除用のスケジュール情報設定
  function onClickDeleteButton(schedule){
    setDeleteSchedule(schedule);
    document.getElementById("open_delete_modal").click();
  }

  function searchSchedule(){
    resetMessages();
    setIsLoading(true);
    axios.get(
    '/api/internal/reserves/history', { params: { institution_key: props.institution_key, plan_kbns: searchPlaKbn}})
    .then(function (response) {
      setSchedules(response.data.d_schedules);
      setIsLoading(false);
    })
    .catch(error => {
      setErrorMessage(error.response.data.message);
      setIsLoading(false);
    }
    );
  }

  // 削除API呼び出し
  function callDeleteSchedule(){
    resetMessages();
    setIsLoading(true);
    axios.delete(
      '/api/internal/reserves/cancel', {
          data: { id: deleteSchedule.id, institution_key: props.institution_key}
      })
      .then(function (response) {
        setInfoMessage(response.data.message);
        setSchedules(
          schedules.filter(function(schedule){
            return schedule.id !== deleteSchedule.id
          })
        );
        setIsLoading(false);

      })
      .catch(error => {
        setErrorMessage(error.response.data.message);
        setIsLoading(false);
      }
  ); 
  }

  function resetMessages(){
    setInfoMessage("");
    setErrorMessage("");
  }


  return(
    <LoadingOverlay active={isLoading} spinner text='Loading...' >
      { errorMessage &&
          <div className="alert fade in alert-danger ">
              <button type="button" className="close" data-dismiss="alert">×</button>
              {errorMessage}
          </div>
      }
      { infoMessage &&
          <div className="alert fade in alert-success ">
              <button type="button" className="close" data-dismiss="alert">×</button>
              {infoMessage}
          </div>
      }
      <div className="row">
        <div className="col-xs-12 col-sm-12">
          <h3 className="mb10">予約一覧</h3>
          {/* 検索エリア */}
          <div id="patient_search_area" className="panel panel-success">
            <div className="panel-heading">検索エリア</div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-2 col-xs-12">
                  <label>ステータス：</label>
                </div>
                <div className="form-group col-lg-8 col-md-8 col-sm-12 col-xs-12">
                  <div className="col-md-4 col-xs-6">
                      <input 
                          type="checkbox" 
                          name="search_template_owner_kbn"
                          id="search_template_owner_kbn_0"
                          value={"40"}
                          defaultChecked={searchPlaKbn.includes("40")}
                          onChange={(e) => changeSearchPlaKbn(e.target)}
                      />
                      <label htmlFor="search_template_owner_kbn_0">予約未確定</label>
                  </div>

                  <div className="col-md-4 col-xs-6">
                      <input 
                          type="checkbox" 
                          name="search_template_owner_kbn"
                          id="search_template_owner_kbn_1"
                          value={"30"}
                          defaultChecked={searchPlaKbn.includes("30")}
                          onChange={(e) => changeSearchPlaKbn(e.target)}
                      />
                      <label htmlFor="search_template_owner_kbn_1">予約確定</label>
                  </div>
                </div>
                <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 mt10 text-right">
                    <input type="submit" name="button_search" value="検索" className="btn btn-lg btn-primary col-lg-12 col-md-12 col-sm-12 col-xs-12" data-disable-with="検索" onClick={() => searchSchedule()}/>
                </div>
              </div> 
            </div>
          </div>

          { schedules.map((schedule) =>
            <div className="reserve-card">
              <div className="mb10 mt10">
                <div className="col-lg-1 col-md-1 col-sm-12 col-xs-12 mb5">
                  {setPlanKbn(schedule.plan_kbn)}
                  
                </div>
                <div className="col-lg-11 col-md-11 col-sm-12 col-xs-12 mb5">
                  <h4 className="bold blue"><a className="reserves_link blue under" href={`/${schedule.institution_key}/reserves/new`}> {schedule.institution_name}</a></h4>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb5">
                  <div className="reserve-time-area alert-secondary">
                  　予約日時：{schedule.plan_datetime_from}
                  </div>
                </div>
                <div className="pull-right col-md-offset-6 col-md-offset-6 col-lg-2 col-md-2 col-sm-12 col-xs-12">
                  <button disabled={schedule.plan_kbn === 30} className="btn btn-lg btn-danger col-lg-12 col-md-12 col-sm-12 col-xs-12 mb5" onClick={() => onClickDeleteButton(schedule)}>予約取消</button>
                  <input type="hidden" id="open_delete_modal" data-toggle="modal" data-target="#schedule_delete_modal"/>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      

      {/* 削除確認モーダル */}
      <div className="modal fade" data-backdrop="static" id="schedule_delete_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
            <div className="sw-modal-icon-question sw-modal-icon">?</div>
            <h2>予約を取り消し</h2>
            <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
            以下の予約を取り消します。<br />
            本当によろしいですか？<br />
            {deleteSchedule.institution_name}<br/>
            {deleteSchedule.plan_datetime_from}<br/>
            </div>
            <a type="button"
                className="sw-modal-btn mb10"
                style={{ backgroundColor: 'red', textDecoration: 'none'}}
                data-dismiss="modal"
                onClick={() => callDeleteSchedule()}
            >
            予約を取消
            </a>
            <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
        </div>
        </div>
      </div>
    </LoadingOverlay>
  )
}
export default Index;